/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  OrderSuccess.tsx
 *
 * Project Title :  Checkout
 *
 * Description      :
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Grandhi Srinivas(E528634)
 *
 * @Date                : Jul 30, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Grandhi Srinivas(E528634)
 * On            : Aug 29, 2019
 * Description   : Updated code as per ASDS-1050.
 *
 * By            : sivateja. peram
 * On            : Sep 30 2019
 * Description   : ASDS-1288
 *
 * By            : H224423
 * On            : Oct 21, 2019
 * Description   : ASDS-1548 changes.
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Nov 4th, 2019
 * Description   : updated the code for ASDS-1298
 *
 * By            : H224423
 * On            : NOV 08, 2019
 * Description   : Implemented Order succes - order details with session storage
 *
 * By            : H224423
 * On            : NOV 08 2019
 * Description   : Notification success changes
 *
 * By            : H224423
 * On            : Dec 09 2019
 * Description   : ASDS-1814 - Place order redirection changes
 *
 * By            : H224423
 * On            : Jan 23 2019
 * Description   : Redirection link issue fixes.
 *
 * By            : H224423
 * On            : Feb 12 2019
 * Description   : ASDS-2270 Removed product redirection changes (ASDS-1814).
 *
 * By            : H224423
 * On            : Mar 12 2020
 * Description   : ASDS-2083 - Product Listing changes
 *
 * By            : H422337
 * On            : Oct,22 2020
 * Description   : ASDS-3601,ASDS-3603 - Enhancements of phase-2
 *
 ******************************************************************************/

import * as React from "react";
import { Grid, Notification } from "@scuf/common";
import "@scuf/common/honeywell/theme.css";
import "./OrderStatus.css";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import RouteConstants from "../constants/route-constants";
import Layout from "../Layout/Layout";
import {
  getPreviousRoute,
  getOrderDetails,
} from "../../../config/sessionStorage";
import { ContactUsMessage } from "../Common/ContactUsMessage";
import ApplyCouponActions from "../redux/actions/apply-coupon-actions";
import { StaticContext } from "react-router";

interface IOrderSuccessState {
  open: any;
  hasClickOut: any;
  orderDetails: any;
}

interface IOrderSuccessProps {
  stateOptions?: any;
  content?: any;
  cartList: any;
  hasApplied: any;
}

export class OrderSuccess extends React.Component<
  IOrderSuccessProps & RouteComponentProps,
  IOrderSuccessState
> {
  constructor(props: IOrderSuccessProps & RouteComponentProps) {
    super(props);
    this.state = {
      open: false,
      hasClickOut: true,
      orderDetails: getOrderDetails(),
    };

    this.backToSearchProducts = this.backToSearchProducts.bind(this);
    this.evaluateCondition = this.evaluateCondition.bind(this);
  }

  componentDidMount() {
    if (this.props.location.pathname === "/order-success") {
      this.props.hasApplied(false);
    }
  }

  // Added this function to go back to purchase Software Page
  backToSearchProducts() {
    this.props.history.push(RouteConstants.PURCHASE_SOFTWARE);
  }
  evaluateCondition() {
    let flag = false;
    if (
      getPreviousRoute() === RouteConstants.ORDER_SUCCESS ||
      this.state.orderDetails.results
    ) {
      flag = true;
    }
    return flag;
  }

  render() {
    /* checks the user allowed to access this component.       */
    return (
      <React.Fragment>
        {this.evaluateCondition() && (
          <Layout>
            <Grid.Row>
              <Grid.Column width={12} className="order-success-panel">
                <Grid>
                  {/************notification starts here************/}
                  <Grid.Row>
                    <Grid.Column width={12} className="success-notify">
                      <Notification
                        className="notification-bar-success"
                        severity="success"
                        detailsText="BACK TO PRODUCT LISTING"
                        onDetailsClick={this.backToSearchProducts}
                        hasIcon={true}
                        title={`Your Order Request is placed successfully and your Order reference number is ${
                          this.state.orderDetails.results &&
                          this.state.orderDetails.results.orderNo
                            ? this.state.orderDetails.results.orderNo.toUpperCase()
                            : "NA"
                        }`}
                        onCloseClick={this.backToSearchProducts}
                      >
                        <Grid className="fullwidthRow">
                          <Grid.Row>
                            <Grid.Column
                              width={12}
                              className="padd-left-0 padd-bottom-0"
                            >
                              <div className="notification-note-text">
                                <ContactUsMessage>
                                  Please note that it may take up to 1 hour for
                                  your order to be processed successfully. You
                                  will receive an order confirmation email along
                                  with Invoice and License Information(If any)
                                  once the order is successfully processed. If
                                  you need help,
                                </ContactUsMessage>
                              </div>
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Notification>
                    </Grid.Column>
                  </Grid.Row>

                  {/************notification ends here************/}
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Layout>
        )}
        {!this.evaluateCondition() && this.backToSearchProducts()}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  hasApplied: ApplyCouponActions.hasApplied,
};

function mapStateToProps(state) {
  return state;
}

// export default withRouter(OrderSuccess);
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrderSuccess)
);
